// Daily Mud Report — template assembly + review checklist. Reuses
// polishProse / MISSING from the existing DDR templates.js (no duplicate code).
import { polishProse, MISSING } from "@/lib/ddr/templates";

const orMissing = (v) => (v && String(v).trim() ? String(v).trim() : MISSING);

export function buildDmrReport(state) {
  const h = state.header || {};
  const m = state.mud || {};
  const v = state.volumes || {};
  const t = state.treatments || {};
  const sc = state.solidsControl || {};
  const gl = state.gainsLosses || {};
  const r = state.recommendations || {};

  const lines = [];
  const push = (s) => { if (s !== null && s !== undefined) lines.push(s); };
  const sec = (label) => lines.push(`\n=== ${label.toUpperCase()} ===\n`);

  sec("Report Header");
  push(`Report Date: ${orMissing(h.reportDate)}`);
  push(`Rig: ${orMissing(h.rigName)}  ·  Well: ${orMissing(h.wellName)}`);
  push(`Operator / Client: ${orMissing(h.operator)}`);
  push(`Mud Engineer / Prepared By: ${orMissing(h.preparedBy)}`);
  push(`Hole Section: ${orMissing(h.holeSection)}  ·  Current Depth: ${orMissing(h.currentDepth)}`);

  sec("Mud System");
  push(`Mud Type: ${orMissing(m.mudType)}`);
  push(`Mud Weight: ${orMissing(m.mudWeight)} ${m.mudWeight ? "ppg" : ""}`);
  push(`Mud Temperature: ${orMissing(m.mudTemp)}`);

  sec("Mud Properties");
  push(`Funnel Viscosity: ${orMissing(m.funnelVisc)} s/qt`);
  push(`PV: ${orMissing(m.pv)} cP  ·  YP: ${orMissing(m.yp)} lb/100ft²`);
  push(`Gel Strengths (10s/10min/30min): ${orMissing(m.gels)}`);
  push(`pH: ${orMissing(m.ph)}  ·  Chlorides: ${orMissing(m.chlorides)} mg/L`);
  push(`Sand: ${orMissing(m.sand)} %  ·  Solids: ${orMissing(m.solids)} %`);
  if (m.owr) push(`Oil / Water Ratio (OBM): ${m.owr}`);
  push(`Fluid Loss: ${orMissing(m.fluidLoss)} mL/30min`);
  if (m.mbt) push(`MBT: ${m.mbt}`);

  sec("Pit / Volume Summary");
  push(`Active Pit Volume: ${orMissing(v.activePit)}`);
  push(`Reserve Pit Volume: ${orMissing(v.reservePit)}`);

  sec("Treatments and Chemicals");
  const chems = polishProse(t.chemicalsAdded);
  push(chems ? `Chemicals Added: ${chems}` : `Chemicals Added: ${MISSING}`);
  const treats = polishProse(t.treatments);
  push(treats ? `Treatments Performed: ${treats}` : `Treatments Performed: ${MISSING}`);

  sec("Solids Control");
  const scStatus = polishProse(sc.status);
  push(scStatus ? `Solids Control Equipment Status: ${scStatus}` : `Solids Control Equipment Status: ${MISSING}`);

  sec("Gains / Losses");
  push(`Gains / Losses: ${orMissing(gl.summary)}`);

  sec("Mud Engineer Notes");
  push(polishProse(state.notes?.roughNotes) || MISSING);

  sec("Recommendations / Next Tour Plan");
  push(polishProse(r.nextTour) || MISSING);

  return lines.join("\n");
}

export function dmrReviewChecklist(state) {
  const out = [];
  const h = state.header || {};
  const m = state.mud || {};
  if (!h.reportDate) out.push("Report date missing");
  if (!h.rigName) out.push("Rig name missing");
  if (!h.wellName) out.push("Well name missing");
  if (!h.preparedBy) out.push("Mud engineer / Prepared-By missing");
  if (!m.mudType) out.push("Mud type missing");
  if (!m.mudWeight) out.push("Mud weight missing");
  if (!state.recommendations?.nextTour) out.push("Next-tour recommendations missing");
  return out;
}

export const DMR_QUICK_PHRASES = [
  "Mud properties within program tolerances.",
  "No mud losses observed.",
  "No gains observed.",
  "Treatments performed per program.",
  "Shakers screens checked.",
  "Centrifuges running normally.",
  "Recommend continue current treatment.",
  "Recommend density increase next tour.",
  "Recommend viscosity reduction next tour.",
];
